import EmployeeProfileSummary from "./EmployeeProfileSummary";

export default EmployeeProfileSummary;
